export default class GetPerfilesCursosByAnioCurso {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(idAnioCurso) {
    try {
      const result = await this.#repository.getPerfilesCursosByAnioCurso(idAnioCurso)
      return result
    } catch (error) {
      throw error
    }
  }
}
